import { useMemo } from "react";
import DottedMap from "dotted-map";

type City = { name: string; lat: number; lng: number };

const CITIES: City[] = [
  { name: "Guatemala City", lat: 14.6349, lng: -90.5069 },
  { name: "Mexico City", lat: 19.4326, lng: -99.1332 },
  { name: "Miami", lat: 25.7617, lng: -80.1918 },
  { name: "Salt Lake City", lat: 40.7608, lng: -111.891 },
  { name: "New York City", lat: 40.7128, lng: -74.006 },
  { name: "Brasilia", lat: -15.7801, lng: -47.9292 },
  { name: "San José", lat: 9.9281, lng: -84.0907 },
  { name: "San Salvador", lat: 13.6929, lng: -89.2182 },
  { name: "Tegucigalpa", lat: 14.0723, lng: -87.1921 },
  { name: "Managua", lat: 12.1364, lng: -86.2514 },
  { name: "Panamá City", lat: 8.9824, lng: -79.5199 },
  { name: "Madrid", lat: 40.4168, lng: -3.7038 },
  { name: "Dubai", lat: 25.2048, lng: 55.2708 },
  { name: "London", lat: 51.5074, lng: -0.1278 },
];

export function PresenceDotMap() {
  const svg = useMemo(() => {
    const map = new DottedMap({ height: 60, grid: "diagonal" });
    CITIES.forEach((c) => {
      map.addPin({
        lat: c.lat,
        lng: c.lng,
        svgOptions: { color: "#ffffff", radius: 0.55 },
      });
    });
    return map.getSVG({
      radius: 0.32,
      color: "#525252",
      shape: "circle",
      backgroundColor: "transparent",
    });
  }, []);

  return (
    <div
      className="w-full [&_svg]:w-full [&_svg]:h-auto"
      aria-hidden
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}